import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { FundService } from '../../services/fund.service'
import { DateService } from '../../services/date.service'
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FundListService } from 'src/app/services/fund-list.service';
import { PerformanceInvestmentService } from 'src/app/services/performance-investment.service';
import { PerformanceCalculationService } from 'src/app/services/performance-calculation.service';
import { Chart } from 'angular-highcharts';
import { DatePipe } from '@angular/common';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';

declare let $: any;

@Component({
    selector: 'app-fund-detail-usd',
    templateUrl: './fund-detail-usd.component.html',
    styleUrls: ['./fund-detail-usd.component.scss']
})
export class FundDetailUsdComponent implements OnInit, OnDestroy {
    language = JSON.parse(localStorage.getItem('language'))

    chartOptions: any = {
        responsive: true,
        legend: {
            fullWidth: 'true',
            position: 'bottom'
        }
    }

    chartOptions1: any = {
        responsive: true,
        legend: {
            position: 'bottom'
        }
    }
    chartColors: any[] = [{
        backgroundColor: 'rgba(0, 255, 0, 0.3)',
        borderColor: 'rgba(0, 131, 42, 1)'
    }];


    chartColors1: any[] = [
        {
            backgroundColor: 'rgba(0, 255, 0, 0)',
            borderColor: 'rgba(0, 21, 177, 1)'
        },
        {
            backgroundColor: 'rgba(0, 255, 0, 0)',
            borderColor: 'rgba(177, 0, 0, 1)'
        },
        {
            backgroundColor: 'rgba(0, 255, 0, 0)',
            borderColor: 'rgba(0, 153,47, 1)'
        },
        {
            backgroundColor: 'rgba(0, 255, 0, 0)',
            borderColor: 'rgba(243, 234,47, 1)'
        }
    ];

    tabtitle: string
    choiceFromSelect: string
    usdvalueDropdown = [
        {
            id: 1,
            value: 'Fund Details'
        },
        {
            id: 2,
            value: 'Performance'
        },
        {
            id: 3,
            value: 'Investment unit trading'
        },
        {
            id: 4,
            value: 'Price and PDF Report'
        }
    ];

    private subscribe: any
    isETF: boolean
    isStoxxUSD: boolean
    isDeviden: boolean
    fundNameEn: string
    fundCode: string
    riskSpectrum: string
    riskSpectrumName: string
    fundDate: string
    navPublish: string
    navDiff: any
    navDiffPercentage: any
    bid: any
    offer: any
    netAsset: any
    divenPolicy: string
    typeName: string
    regName: string
    trusteeName: string
    incepDate: string
    accountPeriod: string
    top5Holding: Array<Object> = []


    dataChart: Array<any> = []
    labelChart: Array<any> = []


    dataChart1: Array<any> = []
    labelChart1: Array<any> = []


    lineChartData: any
    chartLabels: any

    lineChartData1: any
    chartLabels1: any

    doughnutChartLabels: any
    doughnutChartData: any
    donutColors: any

    index_v: any
    FunbId: any
    currency: any

    bind_data1: any

    bind_data2: any

    MinFirstTradeAmt: any
    MinTradeAmt: any
    MinFundGiftCard: any
    BuyTime: any

    MinBalanceUnit: any
    MinSellTradeAmt: any
    MinBalanceBaht: any
    SellTime: any
    SettlementDate: any

    FeeBuy: any
    FeeSell: any
    FeeSwitchIn: any
    FeeSwithOut: any

    FeeRegister: any
    FeeManagement: any
    FeeTrustee: any
    FeeOther: any
    FeeTotal: any

    supporter: any

    dateTab4: any

    Tab4IIV: any
    Tab4NAVPerUnit: any
    Tab4BAAmount: any
    Tab4ValuationDate: any
    Tab4Day: any
    Tab4Month: any
    Tab4Year: any
    responsedate: any
    createNewDate: any
    Tab4PDF: any
    Tab4ETFSymbol: any
    Tab4UnitPerCU: any
    Tab4TotalNavAmount: any
    Tab4NavSub: any
    Tab4NavRed: any
    Tab4ETFMarketID: any
    Tab4ETFISINCode: any
    Tab4Total: any
    // Performance Investment
    investPeriod: string
    investPortfolioCode: string
    investBenchmark: string
    investSd: string
    investSDBenchmark: string
    // data performance reports
    dataPerformanceReports: Array<Object> = []
    investNoteList: []
    investNoteTitle: Array<Object> = []
    investNote: Array<Object> = []

    // Performance Calculation
    // table 1
    portPerformance = []
    portSDPerformance = []
    portBenchmarkObject: object
    portSDBenchmarkObject: object
    portBenchmarkPerformance = []
    portSDBenchmarkPerformance = []
    portPerfNoteTitle: string
    portPerfNote: Array<Object> = []

    // table 2
    returnPerfYear = []
    returnPortPerf = []
    returnPortSDPerf = []
    returnPortBenchObj: object
    returnPortSDBenchObj: object
    returnPortBenchmark = []
    returnPortSDBenchmark = []

    date: string
    date2: string
    fundId: number
    fundId2: number

    invalidPerfInvest: boolean
    invalidFundPerf: boolean

    selectListDropdown = []
    fundList: Array<Object> = [];

    totalPageCount: number
    currentPage = 1
    filterNavHistory: any

    totalDevidendPageCount: number
    devidendCurrentPage = 1
    filterDevidenHistory: any

    // ==== Morning Star =====
    IsFlagMorning: any
    MorningStarLevel: any
    MorningStarDate: any

    // ==== CMS Data =====
    cms_reward: any
    cms_investment_stype: any
    cms_investment_type: any
    cms_investment_policy: any
    cms_id: any;
    doc_list: any;

    ChartName: any
    minVal: any = 0
    maxVal: any = 0
    chart: any
    donut_x: any
    chart_line: any

    exportAsConfig: ExportAsConfig = {
        type: 'xlsx', // the type you want to download
        elementIdOrContent: '', // the id of html/table element
    }

    flag: any

    constructor(private route: ActivatedRoute, private _fundInfoService: FundService,
        private _dateService: DateService, private _performanceInvestService: PerformanceInvestmentService,
        private _performanceCalService: PerformanceCalculationService, private ngxService: NgxUiLoaderService,
        private _fundListService: FundListService, private exportAsService: ExportAsService) {

        this.lineChartData = [
            { data: [], label: '' }
        ]
        this.chartLabels = []
        this.doughnutChartLabels = [];
        this.doughnutChartData = [];
        this.donutColors = [];

        this.lineChartData1 = []
        this.chartLabels1 = []
    }

    ngOnInit() {
        this.flag = localStorage.getItem('language_flag')

        this.ngxService.start();
        this.tabtitle = 'Fund Details'
        this.choiceFromSelect = 'detail'
        this.subscribe = this.route.params.subscribe(params => {
            this.index_v = '1';
            this.FunbId = params['id']
            this.currency = params['currency']
            if (params['currency'] === 'USD') {
                this.isStoxxUSD = true
            } else {
                this.isStoxxUSD = false
            }

            // ========================== data =======================
            this._fundInfoService.getFundInfo(params['id']).subscribe(response => {
                if (response['Result']['FundTypeId'] === '11' || response['Result']['FundCode'] === 'ONE-STOXXASEAN_USD'
                    || response['Result']['FundCode'] === 'ONE-STOXXASEAN') {
                    this.isETF = true
                    this.dateTab4 = this.transform(new Date())
                    if (!this.isStoxxUSD) {
                        this._fundInfoService.GetNAVBasket(params['id'], this.dateTab4).subscribe(response => {

                            this.Tab4IIV = response['Result']['IIV']
                            this.Tab4NAVPerUnit = response['Result']['NAVPerUnit']
                            this.Tab4BAAmount = response['Result']['BAAmount']
                            this.responsedate = response['Result']['ValuationDate']
                            this.Tab4ETFSymbol = response['Result']['ETFSymbol']
                            this.Tab4UnitPerCU = response['Result']['UnitPerCU']
                            this.Tab4TotalNavAmount = response['Result']['TotalNAVAmount']
                            this.Tab4NavSub = response['Result']['NAVSub']
                            this.Tab4NavRed = response['Result']['NAVRed']
                            this.Tab4ETFMarketID = response['Result']['ETFMarketID']
                            this.Tab4ETFISINCode = response['Result']['ETFISINCode']
                            this.Tab4Year = parseInt(this.responsedate.substring(6, 10))
                            this.Tab4Month = parseInt(this.responsedate.substring(3, 5)) - 1
                            this.Tab4Day = parseInt(this.responsedate.substring(0, 2))
                            this.createNewDate = new Date(this.Tab4Year, this.Tab4Month, this.Tab4Day)
                            this.Tab4ValuationDate = this._dateService.changeFormatDate(this.createNewDate)
                        })
                        this._fundInfoService.GetPDFBasket(params['id'], this.dateTab4).subscribe(response => {
                            this.Tab4PDF = response['Result']
                            let x = 0;
                            for (let i = 0; i < response['Result'].length; i++) {
                                const y = +response['Result'][i]['Result']
                                x = x + y
                            }
                            this.Tab4Total = x
                        })
                    }
                } else {
                    this.isETF = false
                }

                if (response['Result']['DividendFlag']) {
                    this.isDeviden = true
                }

                this.fundNameEn = response['Result']['FundNameEn']
                // ===================== vxvxvxvxv ================


                this._fundInfoService.getFundByFundId_Currency(params['id'], params['currency']).subscribe(response => {

                    this.fundCode = response[0]['FundCode']

                    if (response[0]['cms_morningstar_award'] === 'y') {
                        this.IsFlagMorning = 'y';
                    } else {
                        this.IsFlagMorning = 'n';
                    }

                    this.cms_id = response[0]['id']
                    this.MorningStarLevel = response[0]['cms_morningstar_level']
                    this.MorningStarDate = this._dateService.changeFormatDate(response[0]['cms_morningstar_date']);

                    this.cms_reward = response[0]['cms_reward']
                    this.cms_investment_stype = response[0]['cms_investment_stype']
                    this.cms_investment_type = response[0]['cms_investment_type']
                    this.cms_investment_policy = response[0]['cms_investment_policy']

                    this._fundInfoService.getFundDoc(this.cms_id).subscribe(response => {
                        this.doc_list = response
                    })

                    if (params['currency'] === 'USD') {
                        // this.fundDate = this._dateService.changeFormatDate(response[0]['FundPriceDate1']);
                        this.fundDate = this._dateService.changeFormatDate_2(response[0]['FundPriceDate1']);
                        this.navPublish = response[0]['NAVPublish1']
                        this.navDiff = response[0]['NAVDiff']
                        this.navDiffPercentage = response[0]['NAVDiffPercent']
                        this.bid = response[0]['NAVSub']
                        this.offer = response[0]['NAVRed']
                        this.netAsset = response[0]['NetAsset']
                    }

                    this._fundInfoService.getNavMovement_2(params['id']).subscribe(response => {
                        this.dataChart = response['series']['data']
                        this.labelChart = response['date']
                        this.minVal = Math.min(...this.dataChart)
                        this.maxVal = Math.max(...this.dataChart)

                        this.chart = new Chart({
                            chart: {
                                type: 'area',
                                styledMode: true,
                                zoomType: 'x'
                            },
                            legend: {
                                align: 'left'
                            },
                            title: {
                                text: null
                            },
                            xAxis: {
                                categories: this.labelChart,
                            },
                            yAxis: {
                                min: this.minVal,
                                max: this.maxVal,
                                title: {
                                    text: null
                                }
                            },
                            defs: {
                                gradient0: {
                                    tagName: 'linearGradient',
                                    id: 'gradient-0',
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1,
                                    children: [{
                                        tagName: 'stop',
                                        offset: 0
                                    }, {
                                        tagName: 'stop',
                                        offset: 1
                                    }]
                                },
                                gradient1: {
                                    tagName: 'linearGradient',
                                    id: 'gradient-1',
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1,
                                    children: [{
                                        tagName: 'stop',
                                        offset: 0
                                    }, {
                                        tagName: 'stop',
                                        offset: 1
                                    }]
                                }
                            },
                            series: [{
                                type: undefined,
                                name: this.fundNameEn,
                                data: this.dataChart
                            }]
                        });

                    })

                    this._fundInfoService.GetNAVHistory(params['id'], this.fundCode).subscribe(response => {
                        this.bind_data1 = response['Result']
                        this.totalPageCount = this.setTotalPage(this.bind_data1)
                        this.setRenderPerPage(this.bind_data1)
                    })

                })

                // =================================================

                this.riskSpectrum = response['Result']['RiskSpectrumId'] + response['Result']['RiskLevelSpecial']
                this.riskSpectrumName = response['Result']['RiskSpectrumTh']
                this.typeName = response['Result']['FundTypeNameTh']

                if (params['currency'] !== 'USD') {

                    this.navPublish = response['Result']['NavPublish']
                    this.navDiff = response['Result']['NAVDiff']
                    this.navDiffPercentage = response['Result']['NAVDiffPercent']
                    this.bid = response['Result']['Bid']
                    this.offer = response['Result']['Offer']
                    this.netAsset = response['Result']['NetAsset']
                    this.fundDate = this._dateService.changeFormatDate(response['Result']['FundPriceDate1'])

                }
                if (this.flag === 'th') {
                    this.divenPolicy = response['Result']['DividendPolicy']
                    this.accountPeriod = response['Result']['AccountingPeriod']
                    this.FeeBuy = response['Result']['FeeBuy']
                    this.FeeSell = response['Result']['FeeSell']
                    this.FeeManagement = response['Result']['FeeManagement']
                    this.FeeTrustee = response['Result']['FeeTrustee']
                    this.FeeRegister = response['Result']['FeeRegister']
                    this.FeeSwitchIn = response['Result']['FeeSwitchIn']
                    this.FeeSwithOut = response['Result']['FeeSwitchOut']
                    this.FeeTotal = response['Result']['FeeTotal']
                    this.FeeOther = response['Result']['FeeOther']
                } else {
                    this.divenPolicy = response['Result']['DividendPolicyEn']
                    this.accountPeriod = response['Result']['AccountingPeriodEn']
                    this.FeeBuy = response['Result']['FeeBuyEn']
                    this.FeeSell = response['Result']['FeeSellEn']
                    this.FeeManagement = response['Result']['FeeManagementEn']
                    this.FeeTrustee = response['Result']['FeeTrusteeEn']
                    this.FeeRegister = response['Result']['FeeRegisterEn']
                    this.FeeSwitchIn = response['Result']['FeeSwitchInEn']
                    this.FeeSwithOut = response['Result']['FeeSwitchOutEn']
                    this.FeeTotal = response['Result']['FeeTotalEn']
                    this.FeeOther = response['Result']['FeeOtherEn']
                }


                this.regName = response['Result']['RegNameTh']
                this.trusteeName = response['Result']['TrusteeNameTh']
                this.incepDate = this._dateService.changeFormatDate_2(response['Result']['InceptionDate'])
                this.top5Holding = response['Result']['Top5Holding']
                this.MinFirstTradeAmt = +response['Result']['MinFirstTradeAmt']
                this.MinTradeAmt = +response['Result']['MinTradeAmt']
                this.MinFundGiftCard = +response['Result']['MinFundGiftCard']
                this.BuyTime = response['Result']['BuyTime']
                if (response['Result']['MinBalanceUnit'] === '' || response['Result']['MinBalanceUnit'] === '0') {
                    this.MinBalanceUnit = 'ไม่กำหนด'
                } else {
                    this.MinBalanceUnit = response['Result']['MinBalanceUnit']
                }
                if (response['Result']['MinSellTradeAmt'] === '' || response['Result']['MinSellTradeAmt'] === '0') {
                    this.MinSellTradeAmt = 'ไม่กำหนด'
                } else {
                    this.MinSellTradeAmt = response['Result']['MinSellTradeAmt']
                }
                if (response['Result']['MinBalanceBaht'] === '' || response['Result']['MinBalanceBaht'] === '0') {
                    this.MinBalanceBaht = 'ไม่กำหนด'
                } else {
                    this.MinBalanceBaht = response['Result']['MinBalanceBaht']
                }
                this.SellTime = response['Result']['SellTime']
                this.SettlementDate = response['Result']['SettlementDate']

                // ========================= DONUT =====================
                if (response['Result']['Asset'].length > 0) {
                    let i: number
                    for (i = 0; i < response['Result']['Asset'].length; i++) {
                        let xxx: any;
                        const bbb = response['Result']['Asset'][i]['Value']
                        xxx = [response['Result']['Asset'][i]['Key'], bbb]
                        this.doughnutChartData.push(xxx)
                    }

                    this.donut_x = new Chart({
                        chart: {
                            renderTo: 'container',
                            type: 'pie',
                            // styledMode: true,
                            backgroundColor: 'transparent',
                            events: {
                                load: function () {
                                    const renderer = this.renderer
                                    this.series[0].points.forEach((point, i) => {
                                        const marker = renderer.createElement('marker').add(renderer.defs).attr({
                                            markerWidth: 10,
                                            markerHeight: 10,
                                            refX: 5,
                                            refY: 5,
                                            orient: 'auto',
                                            id: `connector-marker-${i}`
                                        });

                                        // renderer.circle(5, 5, 5).add(marker).attr({
                                        //   fill: point.color
                                        // });

                                        // point.connector.attr({
                                        //   'marker-start': `url(#connector-marker-${i})`
                                        // });
                                    })
                                }
                            }

                        },

                        title: {
                            text: null
                        },
                        yAxis: {
                            title: {
                                text: 'Total percent market share'
                            },
                        },
                        plotOptions: {
                            pie: {
                                shadow: false,
                                dataLabels: {
                                    enabled: false,
                                },
                                showInLegend: false,
                            },
                        },

                        tooltip: {
                            formatter: function () {
                                return '<b>' + this.point.name + '</b>: ' + this.y.toFixed(2) + ' %';
                            },
                        },
                        series: [{
                            type: undefined,
                            data: this.doughnutChartData,
                            innerSize: '40%',
                            showInLegend: false,
                            dataLabels: {
                                enabled: true,
                                format: '{point.y:.2f}% <br/> {point.name}',
                                softConnector: false
                            },
                            colorByPoint: true
                        }],

                    });
                }

                // ========================================================

                this.supporter = response['Result']['Supporter']

                // ========================= Devidend Data =================================//
                this._fundInfoService.getDevidendHistory(params['id']).subscribe(response => {
                    this.bind_data2 = response['Result']
                    this.totalDevidendPageCount = this.setDevidendTotalPage(this.bind_data2)
                    this.setRenderDevidend(this.bind_data2)

                })

                // ========================== Chart =======================
            })

            this._fundListService.getFundList().subscribe(response => {
                this.fundList = response['Result']
                this.getFundCode(this.fundList)
            })

            // ========================== Graph =======================

            this._fundInfoService.Graph(params['id'], '1').subscribe(response => {

                this.labelChart1 = response['date']
                let i: number;
                for (i = 0; i < response['series'].length; i++) {
                    this.lineChartData1.push(response['series'][i]['data'])
                    this.chartLabels1.push(response['series'][i]['name_th'])
                }

                this.chart_line = new Chart({
                    title: {
                        text: null
                    },

                    subtitle: {
                        text: null
                    },
                    xAxis: {
                        categories: this.labelChart1,
                    },
                    yAxis: {
                        title: {
                            text: null
                        }
                    },

                    legend: {
                        layout: 'vertical',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0,
                    },
                    series: [{
                        type: undefined,
                        name: this.chartLabels1[0],
                        color: '#0e466d',
                        data: this.lineChartData1[0]
                    }, {
                        type: undefined,
                        name: this.chartLabels1[1],
                        color: '#ad3030',
                        data: this.lineChartData1[1]
                    }]
                })
            })

            this.ngxService.stop();
        })
    }

    transform(value) {
        const datePipe = new DatePipe('en-US');
        value = datePipe.transform(value, 'dd/MM/yyyy')
        return value
    }

    onSearchGraph(index_val) {
        this.ngxService.start();

        this.index_v = index_val;
        this.labelChart1.length = 0;
        this.lineChartData1.length = 0;
        this.chartLabels1.length = 0;
        this._fundInfoService.Graph(this.FunbId, index_val).subscribe(response => {
            this.labelChart1 = response['date']
            let i: number;
            for (i = 0; i < response['series'].length; i++) {
                this.lineChartData1.push(response['series'][i]['data'])
                this.chartLabels1.push(response['series'][i]['name_th'])
            }

            this.chart_line = new Chart({
                title: {
                    text: null
                },

                subtitle: {
                    text: null
                },
                xAxis: {
                    categories: this.labelChart1,
                },
                yAxis: {
                    title: {
                        text: null
                    }
                },

                legend: {
                    layout: 'vertical',
                    verticalAlign: 'bottom',
                    x: 0,
                    y: 0,
                },
                series: [{
                    type: undefined,
                    name: this.chartLabels1[0],
                    color: '#0e466d',
                    data: this.lineChartData1[0]
                }, {
                    type: undefined,
                    name: this.chartLabels1[1],
                    color: '#ad3030',
                    data: this.lineChartData1[1]
                }]


            })

            this.ngxService.stop();

        })
    }

    ngOnDestroy() {
        this.subscribe.unsubscribe()
    }

    setTotalPage(objectFundType) {
        if (Object.keys(objectFundType).length <= 16) {
            return 1
        } else if (Object.keys(objectFundType).length > 16 && Object.keys(objectFundType).length <= 80) {
            return Math.ceil(Object.keys(objectFundType).length / 16)
        } else {
            return 5;
        }
    }

    setDevidendTotalPage(objectFundType) {
        if (Object.keys(objectFundType).length <= 5) {
            return 1
        } else if (Object.keys(objectFundType).length > 5) {
            return Math.ceil(Object.keys(objectFundType).length / 5)
        }
    }

    setCurrentPage($event) {
        this.currentPage = $event
        this.setRenderPerPage(this.bind_data1)
    }

    setDevidendCurrentPage($event) {
        this.devidendCurrentPage = $event
        this.setRenderDevidend(this.bind_data2)
    }

    setRenderPerPage(navHistory) {
        if (navHistory !== undefined) {
            this.filterNavHistory = navHistory.slice(this.currentPage * 16 - 16, this.currentPage * 16)
        }
    }

    setRenderDevidend(devidendHistory) {
        if (devidendHistory !== undefined) {
            this.filterDevidenHistory = devidendHistory.slice(this.devidendCurrentPage * 5 - 5, this.devidendCurrentPage * 5)
        }
    }

    isPositive(value) {
        const x = +value
        if (x > 0) {
            return true

        } else {
            return false
        }
    }

    showOnlyValue(value) {
        return Math.abs(value)
    }

    fixFloatDigit(value) {
        return value.toFixed(2)
    }

    setNumberFormat(value) {
        if (value = ' ') {
            return null
        } else {
            return value.toLocaleString()
        }
    }
    getFundIdFromSelect($event) {
        this.fundId = $event
    }

    getPickDate($event) {
        this.date = $event;
    }

    getFundIdFromSelect2($event) {
        this.fundId2 = $event
    }

    getPickDate2($event) {
        this.date2 = $event;
    }

    setDate1(d1) {
        this.date = d1
    }

    setDate2(d2) {
        this.date2 = d2
    }

    getFundCode(fundList: object) {
        Object.entries(fundList).forEach(
            ([key, value]) => {
                this.showFundCode(value)
            }
        );
    }

    exportFile(tableToExport) {
        if (tableToExport === 'devidend') {
            this.exportAsConfig.elementIdOrContent = 'devidend'
            this.exportAsService.save(this.exportAsConfig, 'Dividen')
        }
    }

    showFundCode(fundCode) {
        this.selectListDropdown.push({ title: fundCode.FundCode, value: fundCode.FundId })
    }

    clickCalculate(menuSelect) {
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.fundId === undefined && (this.date === undefined || this.date === null)) {
            this.invalidPerfInvest = true
            document.getElementsByClassName('selectiongroup')[0].setAttribute('style', 'border: 1px solid red')
        }
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.fundId !== undefined) {
            this.invalidPerfInvest = false
        } else {
            this.invalidPerfInvest = true
        }
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.date !== undefined) {
            document.getElementsByClassName('selectiongroup')[0].setAttribute('style', 'border: 0px solid red')
        }
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.date === null) {
            document.getElementsByClassName('selectiongroup')[0].setAttribute('style', 'border: 1px solid red')
        }
        // Performance Investment
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.fundId !== undefined && this.date !== undefined && this.date !== null) {
            this.ngxService.start();
            this.dataPerformanceReports = []
            this.investNoteTitle = []
            this._performanceInvestService.getPerformanceInvest(this.fundId, this.date).subscribe(response => {
                let i = 2;
                response['Result']['benchmarkList'].map(m => {
                    i++;
                    this.dataPerformanceReports.push(
                        {
                            index: i,
                            value: m['nameshort'],
                            percent: m['INDEX_P1']
                        }
                    );
                });
                this.investPeriod = response['Result']['performance']['p1']
                this.investPortfolioCode = response['Result']['performance']['portfolioCode']
                this.investBenchmark = response['Result']['performance']['NAV_P1']
                this.investSd = response['Result']['performance']['sd']
                this.investSDBenchmark = response['Result']['performance']['SD_P1']
                let j = 0
                response['Result']['noteList'].forEach(element => {
                    j++
                    this.investNoteTitle.push(
                        {
                            index: j,
                            noteTitle: element['nameshort'],
                            noteDetail: element['arrayName']
                        }
                    )
                });
                this.ngxService.stop();
                $('#perModal').modal('show');
            })
        }
    }

    clickCalculate2(menuSelect) {
        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.fundId2 === undefined && (this.date2 === undefined || this.date2 === null)) {
            this.invalidFundPerf = true
            document.getElementsByClassName('selectiongroup')[1].setAttribute('style', 'border: 1px solid red')
        }

        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.fundId2 !== undefined) {
            this.invalidFundPerf = false
        } else {
            this.invalidFundPerf = true
        }

        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.date2 !== undefined) {
            document.getElementsByClassName('selectiongroup')[1].setAttribute('style', 'border: 0px solid red')
        }
        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.date2 === null) {
            document.getElementsByClassName('selectiongroup')[1].setAttribute('style', 'border: 1px solid red')
        }

        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.fundId2 !== undefined && this.date2 !== undefined && this.date2 !== null) {
            this.ngxService.start();
            // clear data
            this.portPerformance = []
            this.portSDPerformance = []
            this.portBenchmarkPerformance = []
            this.portSDBenchmarkPerformance = []
            this.returnPerfYear = []
            this.returnPortPerf = []
            this.returnPortSDPerf = []
            this.returnPortBenchmark = []
            this.returnPortSDBenchmark = []

            this._performanceCalService.getPerformanceSum(this.fundId2, this.date2).subscribe(response => {
                if (response['Success'] === true || response['Success'] == true) {
                    // table 1
                    // row 1
                    this.portPerformance.push(response['Result']['performance']['portfolioCode'])
                    this.portPerformance.push(response['Result']['performance']['dataYTD'])
                    this.portPerformance.push(response['Result']['performance']['data3M'])
                    this.portPerformance.push(response['Result']['performance']['data6M'])
                    this.portPerformance.push(response['Result']['performance']['data1Y'])
                    this.portPerformance.push(response['Result']['performance']['data3Y'])
                    this.portPerformance.push(response['Result']['performance']['data5Y'])
                    this.portPerformance.push(response['Result']['performance']['data10Y'])
                    this.portPerformance.push(response['Result']['performance']['dataSinceInception'])

                    // row 2
                    this.portSDPerformance.push(response['Result']['performance']['sd'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSDYTD'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSD3M'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSD6M'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSD1Y'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSD3Y'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSD5Y'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSD10Y'])
                    this.portSDPerformance.push(response['Result']['performance']['dataSDSinceInception'])

                    // row 3
                    this.portBenchmarkObject = response['Result']['benchmarkList'].find(value => value.nameshort === 'Benchmark 1')
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['nameshort'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P1'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P3'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P4'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P5'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P6'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P7'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P8'])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject['INDEX_P9'])

                    // row 4
                    this.portSDBenchmarkObject = response['Result']['benchmarkList'].find(value => value.nameshort === 'SD Benchmark 1')
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['nameshort'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P1'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P3'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P4'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P5'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P6'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P7'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P8'])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject['INDEX_P9'])

                    // note table 1
                    let i = 0
                    response['Result']['noteList'].forEach(property => {
                        i++
                        this.portPerfNote.push(
                            {
                                index: i,
                                noteTitle: property['nameshort'],
                                noteDetail: property['arrayName']
                            }
                        )
                        // this.portPerfNoteTitle = property["nameshort"]
                        // this.portPerfNote = property["arrayName"]
                    });

                    // table 2
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p1'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p2'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p3'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p4'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p5'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p6'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p7'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p8'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p9'])
                    this.returnPerfYear.push(response['Result']['returnPerformance']['p10'])

                    // row 1
                    this.returnPortPerf.push(response['Result']['returnPerformance']['portfolioCode'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P1'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P2'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P3'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P4'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P5'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P6'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P7'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P8'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P9'])
                    this.returnPortPerf.push(response['Result']['returnPerformance']['NAV_P10'])

                    // row 2
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['sd'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P1'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P2'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P3'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P4'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P5'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P6'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P7'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P8'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P9'])
                    this.returnPortSDPerf.push(response['Result']['returnPerformance']['SD_P10'])

                    // row 3
                    this.returnPortBenchObj = response['Result']['returnBenchmarkList'].find(value => value.nameshort === 'Benchmark 1')
                    this.returnPortBenchmark.push(this.returnPortBenchObj['nameshort'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P1'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P2'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P3'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P4'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P5'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P6'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P7'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P8'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P9'])
                    this.returnPortBenchmark.push(this.returnPortBenchObj['INDEX_P10'])

                    // row 4
                    this.returnPortSDBenchObj = response['Result']['returnBenchmarkList'].find(value => value.nameshort === 'SD Benchmark 1')
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['nameshort'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P1'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P2'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P3'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P4'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P5'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P6'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P7'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P8'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P9'])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj['INDEX_P10'])
                    $('#sumModal').modal('show');
                }
                else{
                    $('#warningModalForformanceSum').modal('show');
                }
                this.ngxService.stop();
            })
        }
    }

    selectValue(event) {
        if (event === 1) {
            this.choiceFromSelect = 'detail'
        } else if (event === 2) {
            this.choiceFromSelect = 'perf'
        } else if (event === 3) {
            this.choiceFromSelect = 'trade'
        } else if (event === 4) {
            this.choiceFromSelect = 'report'
        }
    }

}
